<template>
  <div id="ContainerCustomReports">
     
    <div class="row">
        <div class="col-12">
          <MdTitle v-bind:Text="$tc('customReports.customReTitle', 2)" />          
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="mt-4">
                <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                <div class="row">
                    <div class="col-md-12">
                      <div>
                        <MdTable 
                          v-bind:fields="fields"
                          v-bind:items="items"
                          v-bind:totalRows="totalRows"
                          v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                          v-bind:currentPage="currentPage"
                          v-bind:perPage="perPage"
                          v-bind:pageOptions="pageOptions"
                          v-bind:refTable="refTable"
                           v-bind:ondblClick="handleDblClick"
                          :viewIconEvent="handleViewEvent"
                          :onRowSelected="onRowSelected"
                          :onFiltered="onFiltered"
                          :pageChanged="pageChanged"
                          :perPageFunction="PerPageFunction">
                        </MdTable>
                      </div>  
                    </div>
                </div>
            </div>
        </div>
    </div>

    <customReportsRep v-if="isReportVisible" 
        :closeWindow="closeReport"
        :reportTitle="reportTitle"
        :ReportName="ReportName"
      />
   
  </div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js'
import ShowMessage from '@/components/messages/ShowMessage.js'
import Permission from '@/common/Permission'
import ReportsService from '@/services/reports.service'
import Vue from 'vue'

export default Vue.extend({
    mixins: [ShowMessage,DBFunctions,Permission],
    name: 'CustomReports',

    data() {
        return { 
            filter:null,
            Loading:true,
            fields: [
                { key: 'reportName', sortable: true, label: this.$t('customReports.rName'), class: 'text-rigth' }         
            ],

            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            items: [],

            selected: [],  
            ShowMessageIsEmpty: true,
            refTable: 'selectableTable',
            isReportVisible: false,
            ReportName: '',
            reportTitle: this.$tc('customReports.customRe')
        }
    },

    methods:{

        closeReport() {
            this.isReportVisible = false
        },

        handleDblClick() {

        },

        handleViewEvent(item) {
            this.ReportName = item.reportName
            this.isReportVisible = true
        },

        pageChanged (page) {            
            this.currentPage = page;
            this.parameter.PageNumber = this.currentPage;         
            //this.getListing();
        },

        PerPageFunction(perpage){
            this.perPage = perpage;    
            this.parameter.PageNumber = 1;
            //this.getListing();
        },

        getListing(){
            this.Loading = true;
            this.$emit('load', this.Loading)        

          ReportsService.savedReports()
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.items = response.data;
                        this.totalRows = response.data.length
                    }  
                        this.Loading = false;
                        this.$emit('load', this.Loading);
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.$emit('load', this.Loading); 
                        this.showResponseErrorMessage(error);           
                    }); 
        },

        SearchPatients(){
            this.Loading = true;
            this.$emit('load', this.Loading);
            this.items = []
            this.currentPage = 1;
            this.totalRows = this.items.length;
            this.parameter.PageNumber = 1;
            //this.getListing();
        },

        onRowSelected(items) {
            this.selected = items
        },

        selectAllRows() {
            this.$refs.selectableTable.selectAllRows()
        },

        clearSelected() {
            this.$refs.selectableTable.clearSelected()
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
    },

     mounted() {
        this.getListing()
    },

    created(){
        
    },

    destroyed() {
    }
});
</script>



